import { routeHistory } from '@nackle/biw-web-router';

/**
 * A utility class to help with the site's navigation rather than requiring
 * direct interaction with the `routeHistory` object from the router.
 */
export class Navigation {

    static push( path, options ) {
        // Check to see if the path being pushed is the same path as the current path.
        // If it is the same, simply replace the existing history item with the new one.
        const pushingDuplicate = ( window.location.pathname === path );
        if ( pushingDuplicate ) {
            Navigation.replace( path, options );
        } else {
            routeHistory.push( path, options );
        }
    }

    static replace( path, options ) {
        routeHistory.replace( path, options );
    }

    static back() {
        routeHistory.back();
    }

}
